import { computed, defineComponent } from "vue";

import { Container } from "aurelia-dependency-injection";

import { IEmployeeList, IReassignVisitDetails, IReassignVisitPayload } from "../../vue-interfaces/i-reassign-visit";
import ReassignVisitServiceException, { TaskService } from "../../../services/task.service";
import { ToastrService } from "../../../services/toastr.service";
import { ApplicationEnum } from "../../../enums/enums";
import { IHandleTaskReschuleIssue } from "../../vue-interfaces/i-visit-details";
import { IRescheduleValidations } from "../RescheduleValidations/RescheduleValidation";

import ProductReassign from "../../vue-forms/ReassignForms/ProductReassign/ProductReassign.vue";
import HomeCareReassign from "../../vue-forms/ReassignForms/HomeCareReassign/HomeCareReassign.vue";
import RescheduleValidation from "../RescheduleValidations/RescheduleValidation.vue";

export default defineComponent({
    inject: ["dialogRef"],

    components: {
        ProductReassign,
        HomeCareReassign
    },

    data() {
        return {
            _taskService: null,
            _toastrService: null,
            dialogReference: this.dialogRef as any,
            options: {} as IReassignVisitDetails,
            applicationEnum: ApplicationEnum,
            employeeList: [] as IEmployeeList[],
            isLoading: false as boolean,
            isSaving: false as boolean,
            preSelectedEmpId: null as string
        };
    },

    provide() {
        return {
            dialogRef: computed(() => this.dialogReference)
        };
    },

    created() {
        this._taskService = Container.instance.get(TaskService);
        this._toastrService = Container.instance.get(ToastrService);
    },

    async mounted() {
        this.options = Object.assign({}, this.dialogReference.data.visitDetails);
        this.preSelectedEmpId = this.dialogReference.data?.selectedEmployee;
        if (!!this.options && this.options.Application != ApplicationEnum.HomeCare) {
            try {
                this.isLoading = true;
                const queryParams = {
                    customTaskId: this.options.CustomTaskId,
                    application: this.options.Application,
                    accountId: this.options.AgencyId,
                    patientId: this.options.PatientId
                };
                let employees = await this._taskService.employeeList(queryParams);
                this.employeeList = employees.filter((employee: any) => {
                    return employee.id != this.options.UserId;
                });
            } catch (e) {
                this._toastrService.error({
                    title: `Available Employees Failed`,
                    message: `Fetching Available Employees has failed, please contact Axxess.`
                });
                this.dialogReference.close("cancel");
            } finally {
                this.isLoading = false;
            }
        }
    },

    methods: {
        async reassignVisit(reassignDetails: IReassignVisitDetails) {
            if (!!reassignDetails) {
                try {
                    this.isSaving = true;
                    let reassignPayload: IReassignVisitPayload = {
                        AccountId: reassignDetails.AgencyId,
                        UserId: reassignDetails.EmpId,
                        Application: reassignDetails.Application,
                        EpisodeId: reassignDetails.EpisodeId,
                        PatientId: reassignDetails.PatientId,
                        TaskId: reassignDetails.Id,
                        TypeId: reassignDetails.TypeId,
                        ReasonId: reassignDetails.ReasonId,
                        NotifyUser: reassignDetails.NotifyUser
                    };
                    if (reassignPayload.NotifyUser) {
                        reassignPayload.PatientName = reassignDetails?.PatientName;
                        reassignPayload.VisitDate = reassignDetails?.VisitDate;
                        reassignPayload.VisitTime = reassignDetails?.VisitTime;
                    }
                    const response = await this._taskService.reassignVisit(reassignPayload);
                    if (reassignDetails.Application === ApplicationEnum.HomeCare) {
                        return response;
                    } else {
                        if (response && !response?.isSuccessful) {
                            if (response.errorDetails.taskIssues.length) {
                                response.errorDetails.taskIssues.forEach((taskIssue: any) => {
                                    this._toastrService.error({
                                        title: `Visit Reassigning Failed`,
                                        message: taskIssue.message
                                    });
                                });
                            } else {
                                this._toastrService.error({
                                    title: `Visit Reassigning Failed`,
                                    message: `Reassigning Visit Operation Failed, Please Contact Axxess if issue still persists.`
                                });
                            }
                        } else {
                            this._toastrService.success({
                                title: `Visit Reassigned`,
                                message: `Visit has been successfully reassigned.`
                            });
                            this.dialogReference.close("success");
                        }
                    }
                } catch (e) {
                    if (!(e instanceof ReassignVisitServiceException && e.message == "ERROR_ALREADY_HANDLED")) {
                        this._toastrService.error({
                            title: `Visit Reassigning Failed`,
                            message: `Reassigning Visit Operation Failed, Please Contact Axxess if issue still persists.`
                        });
                    }
                } finally {
                    this.isSaving = false;
                }
            }
        },

        cancel() {
            this.dialogReference.close("cancel");
        },

        ok() {
            this.dialogReference.close("success");
        }
    }
});
